var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.clientReport)?_c('p',{attrs:{"data-test":"no-report-message"}},[_vm._v("No client report found.")]):_c('p',{attrs:{"data-test":"client-name"}},[_vm._v(_vm._s(_vm.clientReport.clientName))])])}
var staticRenderFns = []

export { render, staticRenderFns }